import React from "react";
import { ResourceEnum } from "src/constants/constants.ts";
import type { ModuleOptions } from "src/system/module.types.ts";
import type { SupplierOrderResource } from "@exonn/js-sdk";
import { Positions } from "src/admin/modules/supplier-order/forms/supplier-order/tabs/positions/Positions.tsx";
import { Receipt } from "src/admin/modules/supplier-order/forms/supplier-order/tabs/receipt/Receipt.tsx";
import { History } from "src/admin/modules/supplier-order/forms/supplier-order/tabs/history/History.tsx";

const receivable: SupplierOrderResource["status"][] = [
  "sent",
  "confirmed",
  "partially_received",
  "received",
];

export const module: ModuleOptions<SupplierOrderResource> = {
  resource: ResourceEnum.SupplierOrder,
  // Вкладки (Positionen, Wareneingang, Verlauf) читают данные заказа из контекста формы.
  layoutForm: true,
  bigIcon: <i className="icon-20-selling" />,
  smallIcon: <i className="icon-15-selling" />,

  tabs: {
    edit: {
      getTitle: (resource) =>
        [resource.order_number, resource.supplier?.name]
          .filter(Boolean)
          .join(" · "),
    },
  },

  formTabs: {
    general: {
      title: (t) => t("formTabs.general.title"),
    },
    positions: {
      title: (t) => t("formTabs.positions.title"),
      routeObject: {
        Component: Positions,
      },
      isHidden: ({ data }) => !data?.id,
    },
    receipt: {
      title: (t) => t("formTabs.receipt.title"),
      routeObject: {
        Component: Receipt,
      },
      isHidden: ({ data }) =>
        !data?.id ||
        data.procurement_type === "dropshipper" ||
        !receivable.includes(data.status),
    },
    history: {
      title: (t) => t("formTabs.history.title"),
      routeObject: {
        Component: History,
      },
      isHidden: ({ data }) => !data?.id,
    },
  },
};
